import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import bookingActions from '../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api, { executeAction } from '../../../../../../helpers/api';
import jobActions from '../../../actions';
import { t } from '../../../../../../i18n';

const api = new Api('shifts/unassign');

function* loadData({ payload }) {
  try {
    const { url, method } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result.data;

      yield put(actions.loadDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* unassign({ payload }) {
  try {
    const { id, jobId, pages } = payload;
    const ids = [];
    const array = Object.entries(id);

    array.forEach(item => {
      if (item[1]) {
        ids.push(item[0]);
      }
    });

    const result = yield call(
      sendRequest,
      api.deleteItem,
      { data: { ids, cancellation: { fee_accepted: true } } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(bookingActions.closeRemoveMultidayWorkerModal());

      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.unassigned_successfully', {
            item: t('dash.jobs.bookings.worker_label'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.UNASSIGN, unassign)]);
}
